import styled from 'styled-components';
export const StyledHashrateInformation = styled.div``;
